import axios from "axios";

export const API = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function getVisitorId() {
  let v = localStorage.getItem("sb8_vid");
  if (!v) {
    v = crypto.randomUUID();
    localStorage.setItem("sb8_vid", v);
  }
  return v;
}

export function getUtm() {
  const cached = sessionStorage.getItem("sb8_utm");
  if (cached) return JSON.parse(cached);
  const p = new URLSearchParams(window.location.search);
  const utm = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((k) => {
    const val = p.get(k);
    if (val) utm[k] = val;
  });
  sessionStorage.setItem("sb8_utm", JSON.stringify(utm));
  return utm;
}

export function getDevice() {
  return window.innerWidth < 768 ? "mobile" : "desktop";
}

let variantCache = null;
export async function getVariant() {
  if (variantCache) return variantCache;
  const cached = sessionStorage.getItem("sb8_variant");
  if (cached) {
    variantCache = JSON.parse(cached);
    return variantCache;
  }
  const { data } = await api.get("/api/variant", { params: { visitor_id: getVisitorId() } });
  variantCache = data;
  sessionStorage.setItem("sb8_variant", JSON.stringify(data));
  return data;
}

export async function track(type, meta = {}) {
  try {
    const v = variantCache || JSON.parse(sessionStorage.getItem("sb8_variant") || "null");
    await api.post("/api/events", {
      visitor_id: getVisitorId(),
      type,
      meta,
      variant: v?.variant || null,
      device: getDevice(),
      page: window.location.pathname,
      ...getUtm(),
    });
  } catch (e) {
    /* analytics silencieux */
  }
  trackGA(type, meta);
}

export function initScrollTracking() {
  const thresholds = [25, 50, 75, 100];
  const fired = new Set();
  const onScroll = () => {
    const doc = document.documentElement;
    const max = doc.scrollHeight - window.innerHeight;
    if (max <= 0) return;
    const pct = Math.round((window.scrollY / max) * 100);
    thresholds.forEach((t) => {
      if (pct >= t && !fired.has(t)) {
        fired.add(t);
        track(`scroll_${t}`);
      }
    });
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  return () => window.removeEventListener("scroll", onScroll);
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export function initGA() {
  const id = process.env.REACT_APP_GA4_ID;
  if (!id || localStorage.getItem("sb8_cookie_consent") !== "accepted") return;
  if (document.getElementById("ga4-script")) return;
  const s = document.createElement("script");
  s.id = "ga4-script";
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", id);
}

export function trackGA(event, params = {}) {
  if (window.gtag) window.gtag("event", event, params);
}
